import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';

import TabSingleTextWrapper from '../../../../common/tabSingleTextWrapper';

const PreClinicalPatents = forwardRef(({ permissions: { disableEdit }, data }, ref) => {
  const {
    current: { phases, id: drugId, ingestedId },
    original: { phases: originalData },
    ingested: {
      phases: { data: ingestedData, fieldActions: ingestedActions },
    },
  } = useSelector(state => state.drugs, shallowEqual);

  return (
    <TabSingleTextWrapper
      disableEdit={disableEdit}
      footerData={data}
      data={phases}
      parentKey="phases"
      childKey="patents"
      drugId={drugId}
      ingestedId={ingestedId}
      originalData={originalData}
      ingestedData={ingestedData['patents']}
      ingestionAction={ingestedActions['patents']}
      parentIngestionAction={ingestedActions}
      ref={ref}
    />
  );
});

PreClinicalPatents.propTypes = {
  permissions: PropTypes.object.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    isTab: PropTypes.bool.isRequired,
    tabs: PropTypes.array.isRequired,
  }),
};

PreClinicalPatents.displayName = 'PreClinicalPatents';

export default PreClinicalPatents;
